export const DOCS_URL = 'https://docs.theseus.us/cyclops/getting-started'
